import { color, hsl } from 'd3-color';

export function setLightness(baseColor: string, lightnessPct: number) {
    const hslColor = hsl(color(baseColor)!);
    hslColor.l = lightnessPct;

    return hslColor.formatHex();
}
